import { ReactElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

export const encodeSvg = (reactElement: ReactElement): string => {
  return (
    'data:image/svg+xml,' +
    encodeURIComponent(renderToStaticMarkup(reactElement))
  );
};
